import ChipInput from "./ChipInput";

export default ChipInput;
